export enum DetailsPanelStateType {
  New = 'New',
  Edit = 'Edit',
  None = 'None',
}
